import StatsBoxWrapper from "./StatsBoxWrapper";
import StatsBox from "./StatsBox";

export default StatsBoxWrapper;
export { StatsBox };
